import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { promptVersionPromptFields } from '../../types'

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('room_state_prompt'),
  showTestingTab: nullSafeOptionalBoolean(false),
  requiredPrompts: z
    .array(z.enum(promptVersionPromptFields))
    .default(['primaryPrompt']),
  optionalPrompts: z.array(z.enum(promptVersionPromptFields)).default([]),
  promptSchemas: z
    .record(z.enum(promptVersionPromptFields), z.string())
    .default({}),
  trigger: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'room_state_prompt',
    requiredPrompts: [],
    optionalPrompts: [],
  })
)

export type FirestorePromptRoomStateType = z.infer<typeof schema>
